import * as Yup from 'yup';
import { BoletagemProdutoSchema } from '../boletagem-produto';
import { BoletagemCompraVenda, BoletagemConfirmacao, BoletagemSubMercado, BoletagemTipo, BoletagemTipoContrato } from './model';

export class BoletagemSchema {
  public static id() {
    return Yup.number().positive('Id deve ser um numero positivo');
  }

  public static record() {
    return Yup.object().shape(recordShape);
  }

  public static createForm() {
    const { contraparte, subMercado, confirmacao, numContratoBBCE, tipoEnergia, tipo, gestora, compraVenda, tipoContrato } = recordShape;

    const createFormShape = {
      contraparte: contraparte.required('Contraparte é obrigatório'),
      subMercado: subMercado.required('Sub Mercado é obrigatório'),
      confirmacao: confirmacao.required('Confirmação é obrigatório'),
      numContratoBBCE,
      tipoEnergia: tipoEnergia.required('Tipo Energia é obrigatório'),
      tipo,
      gestora,
      compraVenda: compraVenda.required('Compra/Venda é obrigatório'),
      tipoContrato: tipoContrato.required('Tipo Contrato é obrigatório'),
      produtos: Yup.array().of(BoletagemProdutoSchema.createForm()).min(1, 'Preencha no mínimo 1 item em produtos').required('Produto é obrigatório')
    };

    return Yup.object().shape(createFormShape);
  }

  public static updateForm() {
    const { contraparte, subMercado, confirmacao, numContratoBBCE, gestora } = recordShape;

    const updateFormShape = {
      contraparte,
      subMercado,
      confirmacao,
      numContratoBBCE,
      gestora,
      produtos: Yup.array().of(BoletagemProdutoSchema.updateForm()).min(1, 'Preencha no mínimo 1 item em produtos').required('Produto é obrigatório')
    };

    return Yup.object().shape(updateFormShape);
  }
}

const recordShape = {
  contraparte: Yup.number().typeError('Valor inválido para Contraparte'),
  subMercado: Yup.mixed<BoletagemSubMercado>().oneOf(Object.values(BoletagemSubMercado), `Submercado deve ser "${Object.values(BoletagemSubMercado).join('" ou "')}"`),
  confirmacao: Yup.mixed<BoletagemConfirmacao>().oneOf(Object.values(BoletagemConfirmacao), `Confirmação deve ser "${Object.values(BoletagemConfirmacao).join('" ou "')}"`),
  numContratoBBCE: Yup.string().when('confirmacao', {
    is: (confirmacao: BoletagemConfirmacao) => confirmacao === BoletagemConfirmacao.BBCE,
    then: Yup.string().required('Campo obrigatório')
  }),
  tipoEnergia: Yup.number().typeError('Valor inválido para Tipo de Energia'),
  tipo: Yup.mixed<BoletagemTipo>().oneOf(Object.values(BoletagemTipo), `Tipo deve ser "${Object.values(BoletagemTipo).join('" ou "')}"`),
  gestora: Yup.number().notRequired(),
  compraVenda: Yup.mixed<BoletagemCompraVenda>().oneOf(Object.values(BoletagemCompraVenda), `Tipo deve ser "${Object.values(BoletagemCompraVenda).join('" ou "')}"`),
  tipoContrato: Yup.mixed<BoletagemTipoContrato>().oneOf(Object.values(BoletagemTipoContrato), `Tipo deve ser "${Object.values(BoletagemTipoContrato).join('" ou "')}"`)
};
